import axios from 'axios';


const apiAltitudine = axios.create({
  baseURL: `https://api.open-meteo.com/v1`,
});

export default apiAltitudine;